export function parse(el) {
  const {
    twttr: {
      widgets = {}
    } = {}
  } = global;

  if(widgets.load) {
    widgets.load(el);
  }
}

export function init() {
  // disable eslint - this is Twitter provided code - https://dev.twitter.com/web/javascript/loading
  /* eslint-disable */
  window.twttr = (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0],
      t = window.twttr || {};
    if (d.getElementById(id)) return t;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function(f) {
      t._e.push(f);
    };

    return t;
  }(document, "script", "twitter-wjs"));
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./utils/twitter.js